import { Header } from '../../../components/DataTable/@types/DataTableProps';
import SortType from '../../../components/DataTable/@types/SortType.enum';

const RESOURCE_GROUP_TABLE_HEADERS: Header[] = [
  { displayValue: 'Name', isSortable: true, sortType: SortType.SortOrder, value: 'name' },
  { displayValue: 'Default', isSortable: true, sortType: SortType.SortOrder, value: 'isDefault' },
  { displayValue: 'Resources', isSortable: false },
];

export default RESOURCE_GROUP_TABLE_HEADERS;
